import { Injectable } from '@angular/core';
// import { Http, Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
// import {Observable} from 'rxjs/Observable';
import {Router,ActivatedRoute} from "@angular/router";


import 'rxjs/Rx';

declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class CommonService {
private serviceData:any;
// private admin_nodeApi = 'http://localhost:9000';//for node server api
// private admin_serverImagePath = "http://localhost:9000/images";
// private admin_serverVideoPath = "http://localhost:9000/videos";
// private admin_serverDocumentPath = "http://localhost:9000/document";
private admin_nodeApi = 'https://seagraphs.com:9042';//for node server api
private admin_serverImagePath = "https://seagraphs.com:9042/images";
private admin_serverVideoPath = "https://seagraphs.com:9042/videos";
private admin_serverDocumentPath = "https://seagraphs.com:9042/document";

// private nodeApi = 'http://localhost:8100';//for node server api
// private serverImagePath = "http://localhost:8100/images";
// private serverVideoPath = "http://localhost:8100/videos";

private nodeApi = 'https://seagraphs.com:8100';//for node server api
private serverImagePath = "https://seagraphs.com:8100/images";
private serverVideoPath = "https://seagraphs.com:8100/videos";
 

// private nodeApi = 'http://onlycrm.net:8042';//for node server api
// private serverImagePath = "http://onlycrm.net:8042/images";
// private serverVideoPath = "http://onlycrm.net:8042/videos";

// private nodeApi = 'http://192.168.1.131:8042';//for node server api
// private serverImagePath = "http://192.168.1.131:8042/images";
// private serverVideoPath = "http://192.168.1.131:8042/videos";
public prefix = 'inspectionAnalyticsCompany_'+this.nodeApi+'_';
public ItemsPerPage = [10,20,30];
public DefaultItemsPerPage = 20;
// private serverDocumentPath = "http://localhost:8100/document";
private serverDocumentPath = "https://seagraphs.com:8100/document";
  constructor(private http:HttpClient,private router: Router,
              private route: ActivatedRoute) { }


  
  private extractData(res) {

    this.serviceData = res;
    if(this.serviceData.status == false){
    }
    return this.serviceData || {};
  }
 
  sendRequestToNode(params) {
    this.showLoader();
    // console.log(params.postData);
    params.url = this.nodeApi; // override node api
    
    var resArr;
    if(params.method && params.method == "post")
    {
      resArr = this.http.post(params.url +'/'+ params.path,params.postData) // define a variable server_url to assign the requested url
      .map(this.extractData);
    }

    else if(params.method && params.method == "delete"){
      resArr = this.http.delete(params.url +'/'+ params.path,{params: params.queryParam}) // define a variable server_url to assign the requested url
      .map(this.extractData);
    }
    else if(params.method && params.method == "put"){
      resArr = this.http.put(params.url +'/'+ params.path,params.postData) // define a variable server_url to assign the requested url
      .map(this.extractData);
    }
    else
    {
      resArr = this.http.get(params.url +'/'+ params.path,{params: params.queryParam}) // define a variable server_url to assign the requested url
      .map(this.extractData);
      
    }
    
    return resArr; 
  }

  getNodeApi(isAdmin = false)
  {
    return isAdmin ? this.admin_nodeApi : this.nodeApi;
  }

  getImagePath(isAdmin = false)
  {
    return isAdmin ? this.admin_serverImagePath :  this.serverImagePath;
  }
  getDocumentPath(isAdmin = false)
  {
    return isAdmin ? this.admin_serverDocumentPath :  this.serverDocumentPath;
   // return this.serverDocumentPath;
  }
  getVidepPath(isAdmin = false)
  {
    return isAdmin ? this.admin_serverVideoPath :  this.serverVideoPath;
  }

  hideLoader()
  {
    $('#loader').addClass('myloader-hide');
  }

  showLoader()
  {
    $('#loader').removeClass('myloader-hide');
  }
  getUserDataFromLocalStorage(){
    if(localStorage.getItem(this.prefix+'userData') != 'undefined'){
      return JSON.parse(localStorage.getItem(this.prefix+'userData'));
    }
    return null;
  }

  /**
   * 
   * @param date 
   * @param format = y-m-d,d-m-y,m-d-y 
   */
  formatDate(date,format = "") {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

   
    if(format == 'm-d-y'){
      return [month,year , day].join('-');
    }
    else if(format == 'd-m-y'){
      return [day, month, year].join('-');
    }
    else if(format == 'd-m'){
      return [day, month].join('-');
    }
    else if(format == 'd/m/y'){
      return [day, month, year ].join('/');
    }
    else{
      return [year, month, day].join('-');
    }
    
}

public breadcum:any;
  setBreadcrumb(data){
    
    this.breadcum = data;
  }
  getBreadcrumb(){
    
    // let data = this.breadcum;
    
    // this.breadcum = '';
    // console.log(this.breadcum)
    return this.breadcum;
  }


  
}